export default {
  banner: '横幅区',
  linkAddress: '链接网址',
  moduleOne: '模块一',
  moduleTwo: '模块二',
  moduleThree: '模块三',
  moduleFour: '模块四',
  uploadImg: '上传图片',
  imgSize: '封面尺寸：',
  menucontent: '菜单栏内容显示（最多显示{num}个）'
}
